import Reveal from "@/components/site/Reveal";
import { WHY } from "@/lib/siteData";

export default function WhyB3() {
  return (
    <section id="why" data-testid="why-section" className="relative py-24 lg:py-32 bg-ink overflow-hidden">
      <div className="absolute -top-1/4 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-gold/10 blur-3xl rounded-full pointer-events-none" aria-hidden="true" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-3xl">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.3em] text-gold mb-5">Why B3</p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-heading font-bold tracking-tight text-white text-4xl sm:text-6xl leading-[1.02]">
              Built on quality. <br />
              <span className="text-white/50">Focused on your project.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-7 text-base sm:text-lg text-white/70 leading-relaxed">
              At B3 Contracting LLC, we believe good work starts with good communication. We aim to
              make the process straightforward from the first conversation through the final walkthrough.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-px bg-line border border-line">
          {WHY.map((w, i) => (
            <Reveal key={w.n} delay={i * 0.08} className="bg-ink">
              <div className="p-9 lg:p-10 h-full">
                <span className="font-heading font-bold text-6xl text-transparent [-webkit-text-stroke:1px_#C89E66]">
                  {w.n}
                </span>
                <h3 className="mt-8 font-heading font-semibold text-white text-2xl tracking-tight">{w.title}</h3>
                <p className="mt-3 text-white/60 leading-relaxed">{w.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
